<div class="mr-t--md mr-b--md">
    <div class="jwt-token-card">
        <div class="jwt-token-card--header">
            {{ 'Create JWT Token' | translate }}
        </div>
        <div class="jwt-token-card--body">
            <form [formGroup]="form" novalidate class="mat-form"  #formDirective="ngForm">
                <div *ngIf="errorMessage.length > 0" class="row form-group" role="alert">
                    <div class="col-md-10">
                        <div class="alert alert-danger">
                            <div *ngFor="let error of errorMessage">
                                <i class="fas fa-exclamation-circle" aria-hidden="true"></i>
                                {{ error | translate }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-12">
                        <mat-form-field class="ps-content">
                            <mat-select [placeholder]="'Clinic' | translate" required="required"
                                        formControlName="clinic_id">
                                <mat-option *ngFor="let clinic of clinics; let i = index"
                                            [value]="clinic['id']">
                                    {{ clinic['name'] | translate }}
                                </mat-option>
                            </mat-select>
                            <small class="form-text text-danger"
                                   [hidden]="form.controls.clinic_id.valid || ((form.controls.clinic_id.pristine && !formSubmitted) || form.controls.clinic_id.disabled)">
                                {{ 'This field is required' | translate }}
                            </small>
                        </mat-form-field>
                    </div>
                    <div class="col-xs-12">
                        <mat-form-field class="ps-content">
                            <input type="text" matInput [placeholder]="'External User Id' | translate"
                                   required="required" formControlName="userId"/>
                            <small class="form-text text-danger"
                                   [hidden]="form.controls.userId.valid || ((form.controls.userId.pristine && !formSubmitted) || form.controls.userId.disabled)">
                                {{ 'This field is required' | translate }}
                            </small>
                        </mat-form-field>
                    </div>
                </div>
            </form>
            <div class="row">
                <div class="col-xs-12">
                    <mat-form-field class="ps-content">
                        <textarea type="text" matInput [(ngModel)]="token" [placeholder]="'Token' | translate" rows="3" readonly></textarea>
                    </mat-form-field>
                </div>
                <div class="col-xs-12">
                    <mat-form-field class="ps-content">
                        <textarea type="text" matInput [(ngModel)]="tokenUrl" [placeholder]="'Url' | translate" rows="3" readonly></textarea>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12 text-xs-right">
                    <button type="submit" class="btn btn-primary save" (click)="submit(form.value, form.valid)">
                        {{ 'Create token' | translate }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>